/*
 * HS Activa Page Loader v2
 * Nachbau des dynamicNav-Routers aus defer-nonPriority-bundle.js.
 *
 * Eigenstaendig. Greift nicht ins bestehende Bundle ein.
 * Aktivierung: window.pageLoaderV2 = true  (statt window.loadDynamically)
 *
 * Notbremse zur Laufzeit: window.__pageLoader.disable()
 */
(function () {
  'use strict';

  if (window.__pageLoader) return;
  if (!window.pageLoaderV2) return;
  if (!('fetch' in window) || !('replaceState' in history)) return;

  var CONTAINER = '#MainContent';
  var OVERLAY_DELAY = 180;      // ms bis der Fortschrittsbalken erscheint
  var FETCH_TIMEOUT = 8000;     // ms bis auf harte Navigation umgeschaltet wird
  var CACHE_MAX = 20;
  var CACHE_TTL = 5 * 60 * 1000;
  var PREFETCH_MAX_PARALLEL = 2;

  // Pfade, die nie per XHR getauscht werden duerfen.
  // Wortgrenze am Ende, sonst faengt /cart nicht und /a wuerde /about mitnehmen.
  // customer_authentication = Login-Link im Header (leitet zu Shopify-Auth um),
  // challenge = Captcha, password = Passwortseite, gift_cards = eigene Layouts.
  var SKIP_PATH = /^\/(checkout|account|customer_authentication|challenge|password|gift_cards|apps|a|tools|services|admin|cart|wpm|\.well-known)(\/|$|\?)/i;
  var SKIP_FILE = /\.(pdf|jpe?g|png|gif|webp|svg|zip|csv|xlsx?|docx?|mp4|mp3|txt|xml|json)$/i;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- Cache */

  var cache = {
    map: new Map(),
    pending: new Map(),

    key: function (url) {
      try {
        var u = new URL(url, location.origin);
        return u.pathname + u.search;
      } catch (e) {
        return url;
      }
    },

    get: function (url) {
      var k = this.key(url);
      var hit = this.map.get(k);
      if (!hit) return null;
      if (Date.now() - hit.t > CACHE_TTL) {
        this.map.delete(k);
        return null;
      }
      this.map.delete(k);          // LRU: neu einsortieren
      this.map.set(k, hit);
      return hit.html;
    },

    // Auch abgelaufene Eintraege liefern. Fuer den Zurueck-Button: die Seite
    // sofort aus dem Cache zeigen und im Hintergrund frisch nachladen ist
    // besser, als die Nutzerin auf das Netz warten zu lassen.
    getStale: function (url) {
      var hit = this.map.get(this.key(url));
      return hit ? hit.html : null;
    },

    revalidate: function (url) {
      var self = this;
      var k = this.key(url);
      if (this.pending.has(k)) return;
      var p = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'page-loader' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { if (html) self.set(url, html); self.pending.delete(k); })
        .catch(function () { self.pending.delete(k); });
      this.pending.set(k, p);
    },

    set: function (url, html) {
      var k = this.key(url);
      if (this.map.size >= CACHE_MAX) this.map.delete(this.map.keys().next().value);
      this.map.set(k, { html: html, t: Date.now() });
    },

    fetch: function (url, opts) {
      opts = opts || {};
      var k = this.key(url);
      var hit = this.get(url);
      if (hit) return Promise.resolve(hit);
      if (this.pending.has(k)) return this.pending.get(k);

      var self = this;
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, opts.timeout || FETCH_TIMEOUT);

      var p = fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'page-loader' },
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          // Weiterleitung auf fremde Origin oder auf den Checkout: nicht tauschen.
          if (res.redirected && !isSwappable(res.url)) throw new Error('redirect-out');
          return res.text();
        })
        .then(function (html) {
          clearTimeout(timer);
          self.set(url, html);
          self.pending.delete(k);
          return html;
        })
        .catch(function (err) {
          clearTimeout(timer);
          self.pending.delete(k);
          throw err;
        });

      this.pending.set(k, p);
      return p;
    },

    clear: function () {
      this.map.clear();
      this.pending.clear();
    },

    stats: function () {
      return { entries: this.map.size, pending: this.pending.size, urls: Array.from(this.map.keys()) };
    }
  };

  /* ----------------------------------------------------------- URL-Filter */

  function isSwappable(url, anchor) {
    var u;
    try { u = new URL(url, location.origin); } catch (e) { return false; }
    if (u.origin !== location.origin) return false;
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    if (SKIP_PATH.test(u.pathname)) return false;
    if (SKIP_FILE.test(u.pathname)) return false;
    if (anchor) {
      if (anchor.target && anchor.target !== '_self') return false;
      if (anchor.hasAttribute('download')) return false;
      if (anchor.getAttribute('rel') === 'external') return false;
      if (anchor.closest('[data-no-swap]')) return false;
      // reiner Sprung innerhalb derselben Seite
      if (u.hash && u.pathname === location.pathname && u.search === location.search) return false;
    }
    return true;
  }

  /* -------------------------------------------------------------- Overlay */

  // Optik wie im Original (snippets/loading-overlay.liquid): abgedunkelter
  // Hintergrund plus Kreis-Spinner. Zwei Unterschiede zu v1:
  //   1. Das Overlay haengt am <body>, nicht in #MainContent. Es ueberlebt den
  //      Tausch und muss nicht nach jedem Swap neu gesucht werden.
  //   2. Es erscheint erst nach OVERLAY_DELAY. Navigationen aus dem Cache sind
  //      in ~170 ms fertig, da wuerde ein sofortiges Overlay nur aufblitzen.
  // Der Scroll wird NICHT gesperrt (v1 setzte body.overflow-hidden). Das Overlay
  // schluckt aber Klicks, damit waehrend des Ladens nichts doppelt ausgeloest wird.

  var overlay = null;
  var bar = null;
  var showTimer = null;

  function ensureOverlay() {
    if (overlay) return overlay;

    var css = document.createElement('style');
    css.textContent =
      '#pl-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;' +
      'align-items:center;justify-content:center;background:rgba(0,0,0,.45);' +
      'opacity:0;visibility:hidden;transition:opacity .18s ease;cursor:progress}' +
      '#pl-overlay.on{opacity:1;visibility:visible}' +
      '#pl-overlay .pl-circles{position:relative;width:11.2px;height:11.2px;' +
      'animation:pl-spin 1s infinite linear}' +
      '#pl-overlay .pl-circles i{position:absolute;width:100%;height:100%;' +
      'background:rgb(var(--color-background,255 255 255));border-radius:50%;' +
      'border:1px solid rgba(var(--color-foreground,18 18 18),.5);' +
      'animation:pl-dot 1.25s infinite ease}' +
      '#pl-overlay .pl-circles i:nth-child(1){--r:60}' +
      '#pl-overlay .pl-circles i:nth-child(2){--r:120}' +
      '#pl-overlay .pl-circles i:nth-child(3){--r:180}' +
      '#pl-overlay .pl-circles i:nth-child(4){--r:240}' +
      '#pl-overlay .pl-circles i:nth-child(5){--r:300}' +
      '#pl-overlay .pl-circles i:nth-child(6){--r:360}' +
      '@keyframes pl-dot{0%,100%{transform:rotate(calc(var(--r)*1deg)) translateY(0)}' +
      '50%{transform:rotate(calc(var(--r)*1deg)) translateY(200%)}}' +
      '@keyframes pl-spin{to{transform:rotate(360deg)}}' +
      '#pl-progress{position:fixed;top:0;left:0;height:3px;width:0;z-index:2147483001;' +
      'background:rgb(var(--color-button,51 153 102));opacity:0;pointer-events:none;' +
      'transition:width .2s ease-out,opacity .2s}' +
      '#pl-progress.on{opacity:1}' +
      '@media (prefers-reduced-motion: reduce){' +
      '#pl-overlay{transition:none}' +
      '#pl-overlay .pl-circles,#pl-overlay .pl-circles i{animation-duration:2s}' +
      '#pl-progress{transition:none}}';
    document.head.appendChild(css);

    overlay = document.createElement('div');
    overlay.id = 'pl-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<div class="pl-circles"><i></i><i></i><i></i><i></i><i></i><i></i></div>';
    document.body.appendChild(overlay);

    bar = document.createElement('div');
    bar.id = 'pl-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    return overlay;
  }

  function loadingStart() {
    clearTimeout(showTimer);
    showTimer = setTimeout(function () {
      ensureOverlay().classList.add('on');
      bar.classList.add('on');
      bar.style.width = '35%';
      setTimeout(function () { if (bar.classList.contains('on')) bar.style.width = '70%'; }, 400);
    }, OVERLAY_DELAY);
  }

  function loadingDone() {
    clearTimeout(showTimer);
    if (!overlay) return;
    overlay.classList.remove('on');
    bar.style.width = '100%';
    setTimeout(function () {
      bar.classList.remove('on');
      setTimeout(function () { if (bar) bar.style.width = '0'; }, 220);
    }, 120);
  }

  /* ------------------------------------------------------- Head-Verwaltung */

  // Alles, was aus einer getauschten Seite in den Head wandert, bekommt ein
  // data-pl-gen. Beim naechsten Tausch fliegt die Vorgaenger-Generation raus.
  var generation = 0;

  function syncHead(doc, url) {
    generation++;

    function setMeta(name, value) {
      if (!value) return;
      var attr = name.indexOf(':') > -1 ? 'property' : 'name';
      var el = document.head.querySelector('meta[' + attr + '="' + name + '"]');
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    }

    function pick(sel, attr) {
      var el = doc.querySelector(sel);
      if (!el) return '';
      return attr ? (el.getAttribute(attr) || '') : (el.textContent || '');
    }

    var title = pick('title');
    var desc = pick('meta[name="description"]', 'content');

    if (title) document.title = title;
    setMeta('description', desc);
    setMeta('og:title', title);
    setMeta('og:description', desc);
    setMeta('og:url', url);
    setMeta('og:image', pick('meta[property="og:image"]', 'content'));

    var canonical = document.head.querySelector('link[rel="canonical"]');
    var newCanonical = pick('link[rel="canonical"]', 'href') || url;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', newCanonical);

    // strukturierte Daten: alte generierte raus, neue rein
    Array.prototype.forEach.call(
      document.head.querySelectorAll('script[type="application/ld+json"][data-pl-gen]'),
      function (n) { n.remove(); }
    );
    Array.prototype.forEach.call(
      doc.querySelectorAll('script[type="application/ld+json"]'),
      function (src) {
        var s = document.createElement('script');
        s.type = 'application/ld+json';
        s.setAttribute('data-pl-gen', generation);
        s.textContent = src.textContent;
        document.head.appendChild(s);
      }
    );

    // Stylesheets der neuen Seite nachziehen, aber nur echte <link>, nie <style>.
    // Inline-<style> steckt bereits im getauschten Container. Genau die Dopplung
    // hat den Head in v1 pro Klick um ~70 Knoten wachsen lassen.
    var newDocMain = doc.querySelector(CONTAINER);
    var sources = [doc.head, newDocMain].filter(Boolean);
    sources.forEach(function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('link[rel="stylesheet"]'), function (link) {
        if (link.hasAttribute('data-shopify')) return;
        var href = link.href;
        if (!href) return;
        var existing = document.head.querySelector('link[rel="stylesheet"][href="' + CSS.escape(href) + '"]');
        if (existing) {
          existing.setAttribute('data-pl-gen', generation);  // weiter in Benutzung
          return;
        }
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = href;
        l.setAttribute('data-pl-gen', generation);
        document.head.appendChild(l);
      });
    });

    // Vorgaenger-Generation entsorgen
    Array.prototype.forEach.call(
      document.head.querySelectorAll('link[rel="stylesheet"][data-pl-gen]'),
      function (l) {
        if (Number(l.getAttribute('data-pl-gen')) < generation) l.remove();
      }
    );
  }

  /* ----------------------------------------------------------- Script-Lauf */

  // Scripts aus dem getauschten Container neu erzeugen, damit sie laufen.
  // Reihenfolge bleibt erhalten: externe Scripts werden abgewartet, ABER nur
  // begrenzt. Ohne diese Grenze haengt die komplette Navigation an einem
  // einzigen lahmen Fremd-Script: das Overlay bleibt stehen und der Loader
  // nimmt keine Klicks mehr an. Nach SCRIPT_WAIT laeuft das Script im
  // Hintergrund weiter, die Kette geht trotzdem weiter.
  var SCRIPT_WAIT = 1500;

  function runScripts(container) {
    var scripts = Array.prototype.slice.call(container.querySelectorAll('script'));
    var waits = [];

    scripts.forEach(function (old) {
      if (!old.parentNode) return;
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });

      // Eine Speed-App stellt Drittanbieter-Scripts auf type="delayedExecution"
      // und schaltet sie bei der ersten Nutzereingabe scharf. Dieser Flipper
      // laeuft nur einmal pro echtem Seitenaufruf: Scripts, die per Swap
      // hereinkommen, blieben sonst fuer immer tot (so starben u.a. Fremd-Widgets
      // nach jeder Navigation). Wer hier ankommt, hat schon interagiert, also
      // duerfen sie sofort laufen.
      if (s.getAttribute('type') === 'delayedExecution') s.setAttribute('type', 'text/javascript');

      if (old.src) {
        s.src = old.src;
        // async=false haelt bei dynamisch eingehaengten Scripts die
        // Ausfuehrungsreihenfolge ein, ohne dass wir sie nacheinander laden.
        // Vorher wartete jedes Script auf sein Vorgaengerscript: bei acht
        // Scripts summierte sich das und die Komponenten wurden spaet wach.
        s.async = false;
        waits.push(new Promise(function (resolve) {
          var done = false;
          var finish = function () { if (!done) { done = true; resolve(); } };
          s.onload = s.onerror = finish;
          setTimeout(finish, SCRIPT_WAIT);
        }));
      } else {
        s.textContent = old.textContent;          // Text VOR dem Einhaengen setzen
      }

      try { old.parentNode.replaceChild(s, old); } catch (e) {}
    });

    return Promise.all(waits);
  }

  /* -------------------------------------------------------------- Analytics */

  function syncAnalytics(doc, url) {
    // ShopifyAnalytics.meta wird von Shopify nur gemerged. Auf einer Collection
    // stand in v1 weiterhin das product-Objekt der vorher besuchten PDP.
    try {
      var sa = window.ShopifyAnalytics;
      if (sa && sa.meta) {
        delete sa.meta.product;
        delete sa.meta.collection;
        var found = null;
        Array.prototype.forEach.call(doc.querySelectorAll('script'), function (s) {
          var t = s.textContent || '';
          if (!found && t.indexOf('ShopifyAnalytics') > -1 && t.indexOf('.meta') > -1) found = t;
        });
        if (found) {
          try { (0, eval)(found); } catch (e) { /* nicht kritisch */ }
        }
      }
    } catch (e) { /* nicht kritisch */ }

    // sauberes Signal fuer GTM, unabhaengig vom History-Change-Trigger
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_location: url,
      page_path: new URL(url, location.origin).pathname,
      page_title: document.title,
      page_loader: 'v2'
    });
  }

  /* ----------------------------------------------------------- Navigation */

  var navigating = false;

  function announce(text) {
    var live = document.getElementById('pl-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'pl-live';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      document.body.appendChild(live);
    }
    live.textContent = text;
  }

  // Das theme-eigene publish() iteriert seine Subscriber ohne try/catch. Wirft
  // einer, laufen alle danach nicht mehr. HeaderSearchIcon.onFormReset ruft
  // payload.preventDefault() auf. v1 kam nur deshalb durch, weil es das echte
  // MouseEvent durchreichte. Deshalb hier immer etwas Event-Aehnliches liefern.
  function eventLikePayload(sourceEvent, url) {
    var p = sourceEvent && typeof sourceEvent.preventDefault === 'function'
      ? sourceEvent
      : { type: 'pageloader', preventDefault: function () {}, stopPropagation: function () {}, target: null };
    try { p.url = url; } catch (e) {}
    return p;
  }

  /* ----------------------------------------------------------------- Scroll */

  // Hoehe des fixierten Headers. Ankersprünge und Scroll-nach-oben müssen sie
  // abziehen, sonst verschwindet das Ziel (z.B. die Produkt-H1) darunter.
  function headerOffset() {
    var h = document.querySelector('header-wrapper') || document.querySelector('header');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return 0;
    return Math.round(h.getBoundingClientRect().height) || 0;
  }

  // Nach dem Tausch laden Bilder, Schriften und Apps nach und schieben das
  // Layout. Ein einmaliges scrollTo reicht deshalb nicht: die Position wird
  // ueber ein paar Frames nachgehalten, bis die Nutzerin selbst scrollt.
  var scrollWatcher = null;

  var STOP_EVENTS = ['wheel', 'touchstart', 'keydown', 'pointerdown'];

  function stopScrollWatch() {
    if (!scrollWatcher) return;
    STOP_EVENTS.forEach(function (t) {
      window.removeEventListener(t, stopScrollWatch, true);
    });
    clearInterval(scrollWatcher);
    scrollWatcher = null;
    document.documentElement.style.overflowAnchor = '';
  }

  function settleScroll(want, dauer) {
    stopScrollWatch();
    // Chrome verankert den Scroll an sichtbaren Elementen. Laedt oberhalb des
    // Viewports etwas nach (Sterne, Badges, Bilder ohne feste Hoehe), schiebt
    // der Browser die Seite nach unten. Genau das laesst die Ueberschrift
    // angeschnitten wirken. Waehrend des Nachhaltens abschalten.
    document.documentElement.style.overflowAnchor = 'none';
    var apply = function () { window.scrollTo(0, want); };
    apply();
    STOP_EVENTS.forEach(function (t) {
      window.addEventListener(t, stopScrollWatch, true);
    });
    // An der Uhr messen, nicht an Ticks: in Hintergrund-Tabs drosselt der
    // Browser setInterval auf einen Aufruf pro Sekunde.
    var until = Date.now() + (dauer || 800);
    scrollWatcher = setInterval(function () {
      if (Math.abs(window.scrollY - want) > 2) apply();
      if (Date.now() > until) stopScrollWatch();
    }, 50);
    setTimeout(stopScrollWatch, 2000);        // Notbremse, falls der Timer haengt
  }

  // Ankerlinks auf derselben Seite selbst behandeln, damit das Ziel nicht unter
  // dem fixierten Header landet. Betrifft u.a. die Bewertungssterne unter der
  // Produktueberschrift, die auf #bewertungen zeigen.
  function handleHashLink(hash) {
    var id = decodeURIComponent(hash.slice(1));
    if (!id) return false;
    var el = document.getElementById(id) || document.querySelector('[name="' + CSS.escape(id) + '"]');
    if (!el) return false;
    var top = Math.max(0, window.scrollY + el.getBoundingClientRect().top - headerOffset() - 16);
    stopScrollWatch();
    window.scrollTo({ top: top, left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    try { history.replaceState(history.state, '', hash); } catch (e) {}
    window.__pageLoaderLastAnchor = { id: id, top: top, headerOffset: headerOffset() };
    return true;
  }

  // onSwapped wird aufgerufen, sobald der neue Inhalt steht und die Position
  // sitzt. NICHT erst, wenn auch das letzte Fremd-Script geladen hat. Genau
  // daran hing das Overlay vorher: die Seite war laengst da und trotzdem lag
  // noch die graue Schicht drueber, die zusaetzlich Klicks geschluckt hat.
  function applyDocument(html, url, scrollTo, sourceEvent, onSwapped) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var incoming = doc.querySelector(CONTAINER);
    var target = document.querySelector(CONTAINER);
    if (!incoming || !target) throw new Error('kein ' + CONTAINER);

    function swap() {
      target.innerHTML = incoming.innerHTML;
      syncHead(doc, url);
      settleScroll(scrollTo || 0);
      if (onSwapped) { try { onSwapped(); } catch (e) {} }
      return runScripts(target);
    }

    // View Transitions vorerst aus: der Snapshot-Mechanismus ist eine weitere
    // Variable beim Scroll-Verhalten und der Nutzen ist rein kosmetisch.
    // Zum Ausprobieren window.pageLoaderViewTransitions = true setzen.
    var swapped = (window.pageLoaderViewTransitions && !reducedMotion && document.startViewTransition)
      ? Promise.resolve(document.startViewTransition(swap).finished).catch(function () {})
      : swap();

    return Promise.resolve(swapped).then(function () {
      syncAnalytics(doc, url);

      // Re-Init. rAF mit Fallback, damit es auch in versteckten Tabs laeuft.
      var fired = false;
      var fire = function () {
        if (fired) return;
        fired = true;
        try { window.dispatchEvent(new Event('load')); } catch (e) {}
        try { document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true })); } catch (e) {}
        // PUB_SUB_EVENTS ist im Theme ein top-level const und liegt deshalb NICHT
        // an window. Nur der blanke Bezeichner findet es.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.siteLoaded, eventLikePayload(sourceEvent, url)); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('pageloader:loaded', { detail: { url: url }, bubbles: true }));
        setupViewportPrefetch();               // Links der neuen Seite beobachten
      };
      requestAnimationFrame(fire);
      setTimeout(fire, 120);

      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      announce(document.title);
    });
  }

  function navigate(url, opts) {
    opts = opts || {};
    if (navigating && !opts.fromPopState) return;
    navigating = true;
    currentKey = cache.key(url);

    if (!opts.fromPopState) {
      var state = history.state || {};
      state.scrollY = window.scrollY;
      history.replaceState(state, '', location.href);
      history.pushState({ scrollY: 0, pageLoader: true }, '', url);
    }

    if (window.overlayManager && window.overlayManager.closeAll) {
      try { window.overlayManager.closeAll(null, opts.event); } catch (e) {}
    }
    document.querySelectorAll('summary[aria-expanded]').forEach(function (s) {
      s.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.header__active-menu-item').forEach(function (el) {
      el.classList.remove('header__active-menu-item');
    });

    loadingStart();

    // Notbremse: das Overlay darf unter keinen Umstaenden haengenbleiben und
    // der Loader nie dauerhaft blockiert sein, egal was schiefgeht.
    var deadman = setTimeout(function () {
      if (!navigating) return;
      console.warn('[page-loader] Navigation haengt, gebe wieder frei:', url);
      navigating = false;
      loadingDone();
    }, FETCH_TIMEOUT + 4000);

    // Freigabe passiert, sobald der Inhalt steht. Die Scripts laufen danach im
    // Hintergrund weiter, ohne dass die Nutzerin darauf warten muss.
    var released = false;
    var release = function () {
      if (released) return;
      released = true;
      clearTimeout(deadman);
      loadingDone();
      navigating = false;
    };

    // Zurueck/Vor: abgelaufener Cache ist besser als Warten. Sofort zeigen,
    // im Hintergrund frisch holen, damit der naechste Besuch aktuell ist.
    var quelle;
    if (opts.fromPopState) {
      var stale = cache.getStale(url);
      if (stale) {
        quelle = Promise.resolve(stale);
        cache.revalidate(url);
      }
    }
    quelle = quelle || cache.fetch(url);

    // INP-FIX 02.09.2026: Liegt die Zielseite schon im Cache, ist das Promise sofort
    // erfuellt und der komplette Seitentausch (innerHTML, Stylesheets, Skript-Neustart,
    // Slider-Init) lief als Microtask NOCH IM KLICK-TASK. Gemessen: Link-Tipp 4,1 s
    // (Startseite) bis 11,3 s (Produktseite) Interaktionsdauer, alles dem Tipp zugerechnet.
    // Deshalb erst einen Frame zeichnen lassen (der Klick gilt damit als beantwortet;
    // ein Ladebalken erscheint bei Cache-Treffern weiterhin nicht, die Wartezeit liegt
    // unter OVERLAY_DELAY), dann tauschen. Der Tausch selbst ist unveraendert und genauso schnell.
    // In versteckten Tabs feuert rAF nicht: Fallback nach 120 ms.
    return quelle
      .then(function (html) {
        return new Promise(function (resolve) {
          var done = false;
          var go = function () { if (done) return; done = true; resolve(html); };
          try { requestAnimationFrame(function () { setTimeout(go, 0); }); } catch (e) { setTimeout(go, 0); }
          setTimeout(go, 120);
        });
      })
      .then(function (html) {
        return applyDocument(html, url, opts.scrollY || 0, opts.event, release);
      })
      .then(release)
      .catch(function (err) {
        // Kein toter Klick: im Zweifel hart navigieren.
        clearTimeout(deadman);
        console.warn('[page-loader] Fallback auf harte Navigation:', err && err.message);
        navigating = false;
        loadingDone();
        if (released) return;          // Inhalt stand schon, kein Neuladen
        location.assign(url);
      });
  }

  /* ------------------------------------------------------------- Prefetch */

  var prefetched = new Set();
  var inFlight = 0;

  function connectionOk() {
    var c = navigator.connection;
    if (!c) return true;
    if (c.saveData) return false;
    if (/(^|-)2g$/.test(c.effectiveType || '')) return false;
    return true;
  }

  function prefetch(url) {
    if (!connectionOk()) return;
    var k = cache.key(url);
    if (prefetched.has(k) || inFlight >= PREFETCH_MAX_PARALLEL) return;
    if (cache.get(url)) return;
    prefetched.add(k);
    inFlight++;
    cache.fetch(url, { timeout: 5000 })
      .catch(function () { prefetched.delete(k); })
      .then(function () { inFlight--; });
  }

  function anchorFrom(node) {
    while (node && node.tagName !== 'A') node = node.parentElement;
    return node;
  }

  // Viewport-Prefetch: sichtbare Produkt-/Kategorielinks in Leerlaufzeiten
  // vorladen. Auf Touch-Geraeten gibt es kein Hover, dort ist das der einzige
  // Weg, den Cache VOR dem Tipp zu fuellen. Bewusst gedeckelt.
  var VIEWPORT_PREFETCH_MAX = 6;
  var viewportPrefetched = 0;
  var viewportObserver = null;

  function setupViewportPrefetch() {
    if (!('IntersectionObserver' in window)) return;
    if (viewportObserver) viewportObserver.disconnect();
    viewportPrefetched = 0;
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 300); };
    viewportObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        viewportObserver.unobserve(en.target);
        if (viewportPrefetched >= VIEWPORT_PREFETCH_MAX) return;
        var href = en.target.href;
        if (!isSwappable(href, en.target)) return;
        if (cache.key(href) === cache.key(location.href)) return;
        viewportPrefetched++;
        idle(function () { prefetch(href); });
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('a[href*="/products/"], a[href*="/collections/"]').forEach(function (a) {
      if (a.id !== 'cart-icon-bubble') viewportObserver.observe(a);
    });
  }

  function maybePrefetch(e) {
    var a = anchorFrom(e.target);
    if (!a || !a.href) return;
    if (a.id === 'cart-icon-bubble') return;
    if (!isSwappable(a.href, a)) return;
    if (cache.key(a.href) === cache.key(location.href)) return;
    prefetch(a.href);
  }

  /* ----------------------------------------------------------------- Init */

  function onClick(e) {
    // Modifier und Nicht-Linksklick gehen an den Browser. Cmd-Klick muss
    // weiterhin einen neuen Tab oeffnen.
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = anchorFrom(e.target);
    if (!a || !a.href) return;
    if (a.id === 'cart-icon-bubble') return;

    // Anker auf derselben Seite: selbst scrollen, mit Header-Abzug.
    var u;
    try { u = new URL(a.href, location.origin); } catch (err) { return; }
    if (u.hash && u.origin === location.origin &&
        u.pathname === location.pathname && u.search === location.search) {
      // Immer abfangen. Ein leeres oder unauffindbares Ziel wuerde der Browser
      // sonst als Sprung nach ganz oben behandeln, und genau das passiert bei
      // Modals und Widgets, die href="#" als reinen JS-Aufhaenger benutzen
      // (z.B. das Schliessen fremder Lightboxen).
      e.preventDefault();
      var id = u.hash.slice(1);
      if (id === 'top') { settleScroll(0); return; }
      handleHashLink(u.hash);
      return;
    }

    if (!isSwappable(a.href, a)) return;
    if (a.href === location.href) { e.preventDefault(); return; }

    e.preventDefault();

    if (a.id === 'HeaderMenu-catalog') {
      var span = a.getElementsByTagName('span')[0];
      if (span) span.classList.add('header__active-menu-item');
    }

    navigate(a.href, { event: e });
  }

  // Welche Seite steht gerade wirklich im Container. Ohne diesen Abgleich
  // behandelt der Loader jeden History-Schritt als Seitenwechsel. Manche Overlays
  // (Lightboxen) legen aber eigene History-Eintraege an und
  // schliessen sich per history.back(): die Seite wurde dann komplett neu
  // aufgebaut und sprang nach oben, obwohl sich die URL gar nicht geaendert hat.
  var currentKey = null;

  function onPopState(e) {
    var url = location.href;
    if (window.__plIgnorePop) { window.__plIgnorePop = false; return; }
    if (!isSwappable(url)) { location.reload(); return; }

    if (cache.key(url) === currentKey) {
      // gleiche Seite, nur ein History-Schritt von fremdem Code (z.B. eine
      // Lightbox, die sich per history.back() schliesst). Nichts neu
      // bauen. Die Position gegen nachlaufende Fremd-Scrolls halten.
      var h = location.hash;
      if (h && h.length > 1) { handleHashLink(h); return; }
      settleScroll(window.scrollY, 1200);
      return;
    }

    var state = e.state || {};
    currentKey = cache.key(url);
    navigate(url, { fromPopState: true, scrollY: state.scrollY || 0, event: e });
  }

  var listeners = [];
  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    listeners.push([target, type, fn, opts]);
  }

  function start() {
    on(document.body, 'click', onClick);
    on(window, 'popstate', onPopState);
    on(document.body, 'mouseover', maybePrefetch, { passive: true });
    on(document.body, 'touchstart', maybePrefetch, { passive: true });
    on(document.body, 'focusin', maybePrefetch, { passive: true });

    // Warenkorb-Aenderung entwertet gecachtes HTML (Preise, Bestand, Staffeln).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          cache.clear();
          prefetched.clear();
        });
      } catch (e) {}
    }

    currentKey = cache.key(location.href);
    setupViewportPrefetch();

    // Der Browser darf nicht selbst zurueckscrollen, sonst kaempft seine
    // Wiederherstellung gegen unsere und man landet irgendwo dazwischen.
    try { history.scrollRestoration = 'manual'; } catch (e) {}

    // Ausgangszustand fuer den Zurueck-Button festhalten
    if (!history.state || !history.state.pageLoader) {
      history.replaceState({ scrollY: window.scrollY, pageLoader: true }, '', location.href);
    }
  }

  window.__pageLoader = {
    version: 2,
    cache: cache,
    navigate: navigate,
    prefetch: prefetch,
    stats: function () { return cache.stats(); },
    headerOffset: headerOffset,

    disable: function () {
      listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      listeners = [];
      stopScrollWatch();
      try { history.scrollRestoration = 'auto'; } catch (e) {}
      cache.clear();
      console.info('[page-loader] deaktiviert, ab jetzt normale Navigation');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
